
import React from 'react';
import { Award, Star, TrendingUp } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import XPProgress from './XPProgress';
import BadgeDisplay from './BadgeDisplay';
import { Badge as BadgeType, UserProfile } from '@/types';

interface ArtistJourneyProps {
  badges: BadgeType[];
  userProfile?: UserProfile;
}

const ArtistJourney: React.FC<ArtistJourneyProps> = ({ badges, userProfile }) => {
  return (
    <Card className="overflow-hidden border border-purple-500/20 shadow-md bg-card">
      <CardHeader className="pb-2 border-b">
        <CardTitle className="text-xl flex items-center gap-2">
          <TrendingUp className="h-5 w-5 text-purple-500" />
          Your Progress Overview
        </CardTitle>
      </CardHeader>
      
      <CardContent className="pt-4">
        <div className="mb-6">
          <XPProgress 
            xp={userProfile?.xp || 1250} 
            level={userProfile?.level || 4} 
            nextLevelXp={2000} 
          />
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div>
            <h3 className="text-sm font-medium flex items-center gap-2 mb-3">
              <Award className="h-4 w-4 text-amber-500" />
              Recent Achievements
            </h3>
            <div className="space-y-2">
              <div className="flex items-center gap-3 p-3 rounded-lg border bg-card hover:bg-accent/5 transition-colors">
                <div className="flex-shrink-0 w-8 h-8 rounded-full bg-green-500/10 flex items-center justify-center">
                  <Star className="h-4 w-4 text-green-500" />
                </div>
                <div>
                  <p className="font-medium">First Collaboration</p>
                  <p className="text-xs text-muted-foreground">Earned 2 days ago</p>
                </div>
              </div>
              
              <div className="flex items-center gap-3 p-3 rounded-lg border bg-card hover:bg-accent/5 transition-colors">
                <div className="flex-shrink-0 w-8 h-8 rounded-full bg-blue-500/10 flex items-center justify-center">
                  <Star className="h-4 w-4 text-blue-500" />
                </div>
                <div>
                  <p className="font-medium">30 Day Streak</p>
                  <p className="text-xs text-muted-foreground">Earned 1 week ago</p>
                </div>
              </div>
            </div>
          </div>
          
          <div>
            <h3 className="text-sm font-medium flex items-center gap-2 mb-3">
              <Award className="h-4 w-4 text-amber-500" />
              Earned Badges
            </h3>
            <BadgeDisplay badges={badges.slice(0, 4)} compact={true} />
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default ArtistJourney;
